var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDeleteMessageIcon = function SvgDeleteMessageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.862 2.5c.548 0 1.04.335 1.24.844l.53 1.346h3.215v1.333h-1.35l-.511 10.26a1.281 1.281 0 0 1-1.28 1.217H6.283a1.281 1.281 0 0 1-1.28-1.217l-.514-10.26H3.142V4.69h3.213l.531-1.346c.2-.51.692-.844 1.24-.844h3.736zM7.97 7.892l2.046 2.045 2.006-2.005 1.203 1.203-2.005 2.005 1.965 1.966-1.203 1.204-1.966-1.966L8.01 14.35l-1.203-1.203 2.005-2.006-2.045-2.046L7.97 7.892zm3.892-4.06H8.126l-.339.858H12.2l-.338-.858z",
    fillRule: "evenodd",
    fill: "#545454"
  }))));
};

export default SvgDeleteMessageIcon;